export const CLIENT_KINDS = ["browser", "headless", "script"] as const;

export type ClientKind = (typeof CLIENT_KINDS)[number];

export const SCRAPER_NOTE = "we know what you are doing :) reach out if you'd like direct api access - colin@upside.tools";

const HEADLESS = /headless|puppeteer|playwright|selenium/i;
const FULL_VERSION_DESKTOP_CHROME =
  /^Mozilla\/5\.0 \((?:Windows NT 10\.0; Win64; x64|Macintosh; Intel Mac OS X 10_15_7|X11; Linux (?:x86_64|aarch64))\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/(\d+)\.0\.[1-9]\d*\.\d+ Safari\/537\.36$/;
const MIN_STRIPPED_HEADLESS_MAJOR = 110;
const BROWSER = /^Mozilla\/5\.0 \(/;

function isStrippedHeadless(ua: string): boolean {
  const major = FULL_VERSION_DESKTOP_CHROME.exec(ua)?.[1];
  return major !== undefined && Number(major) >= MIN_STRIPPED_HEADLESS_MAJOR;
}

export function classifyClient(userAgent: string | null): ClientKind {
  const ua = userAgent ?? "";
  if (HEADLESS.test(ua) || isStrippedHeadless(ua)) return "headless";
  return BROWSER.test(ua) ? "browser" : "script";
}
